import React, { useEffect, useState } from "react";
import Navbars from "../../common/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import superAdminApis from "../../api/services/admin-pages/superAdmin";
import { baseURL } from "../../api/api";
import NoImage from "../../assets/img/noimages.jpg";
import './index.css'

import AOS from "aos";
import "aos/dist/aos.css";
import { FaPrint } from "react-icons/fa";

function CustomerView() {


    useEffect(() => {
          AOS.init({
            duration: 1000,  
            once: false,    
            mirror: true,    
          });
        }, []);



  const navigate = useNavigate();
  const { id } = useParams();
  const baseURLs = baseURL;
  const [customer, setCustomer] = useState(null);


  console.log(customer)

  const handleBackCustomer = () => {
    navigate("/customer-details-list");
  };

useEffect(() => {
  if (id) {
    superAdminApis
      .customerDetailsGet(id)
      .then((res) => {
        if (res?.apiStatus?.code === "200") {
          const result = Array.isArray(res.result) ? res.result[0] : res.result;

          // ✅ Ensure valid existing_details array
          const existingDetails =
            Array.isArray(result?.existing_details) &&
            result.existing_details.length > 0 &&
            result.existing_details[0] !== null
              ? result.existing_details
              : [];

          // ✅ Flatten payment-like details
          let mergedList = [];

          existingDetails.forEach((item) => {
            if (!item) return;
            Object.values(item).forEach((entry) => {
              if (!entry) return;

              mergedList.push({
                month_no: mergedList.length + 1,
                loan_id : entry.loan_id,
                name : entry.name,
                payment_date:
                  entry.last_payment_date && entry.last_payment_date !== "0000-00-00"
                    ? entry.last_payment_date
                    : entry.updated_date || entry.created_date || "-",
                interest_paid: entry.interest_paid || 0,
                principal_paid: entry.principal_paid || 0,
                total_paid:
                  Number(entry.interest_paid || 0) + Number(entry.principal_paid || 0),
                balance:
                  entry.balance ||
                  entry.remaining_balance ||
                  entry.total_amount ||
                  result.loan_amount ||
                  0,
              });
            });
          });

          console.log("✅ Final merged history:", mergedList);

          // ✅ Set final customer data
          setCustomer({
            ...result,
            mergedHistory: mergedList,
          });
        } else {
          console.error("❌ API returned non-200 status:", res);
         setCustomer({}); 
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching details:", err);
       setCustomer({}); 
      });
  }
}, [id]);






if (!customer) {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <div className="gold-dots-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

  // 🧮 BASIC CALCULATIONS
  const loanAmount = Number(customer.loan_amount || 0);
  const principalPaid = Number(customer.principal_paid || 0);
  const interestPaid = Number(customer.interest_amount || 0);
  const totalPaid = principalPaid + interestPaid;

  // ✅ Remaining Principal
  let principalRemaining = loanAmount - principalPaid;
  if (principalRemaining < 0) principalRemaining = 0;

  // ✅ If paid fully, mark status as closed
  const loanStatus =
    principalRemaining === 0 ? "Closed" : customer.paid_status || "Active";

  // ✅ Balance for display
  const balance = principalRemaining.toFixed(2);

   const formatTime = (dateStr) => {
    if (!dateStr || dateStr === "0000-00-00") return "—";
    const d = new Date(dateStr.replace(" ", "T"));
    return d.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // show AM/PM
    });
  };

// const formatDate = (dateStr) => {
//     if (!dateStr || dateStr === "0000-00-00") return "—";
//     const d = new Date(dateStr.replace(" ", "T"));
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });
//   };



const handlePrint = (row) => {
  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
    <html>
      <head>
        <title>Payment Summary</title>
        <style>
        * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            margin: 0;
            padding: 20px;
            background: #f7f7f7 !important;
            color: #333 !important;
          }
.print-card .card {
padding:10px;
  background: #f0babaff;
}
          .print-card {
            max-width: 450px;
            margin: 0 auto;
            padding: 25px;
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 6px 15px rgba(0,0,0,0.1) !important;
            border-top: 4px solid #007bff !important;
          }

          .print-card h2 {
            text-align: center;
            margin-bottom: 30px;
            font-size: 22px;
            color: #007bff !important;
          }

          .row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
          }

          .row label {
            font-weight: 600;
            color: #555 !important;
          }

          .row span {
            font-weight: 500;
          }

          .total {
            margin-top: 20px;
            margin-bottom :30px;
            padding-top: 10px;
            border-top: 1px dashed #ccc !important;
            font-size: 18px;
            font-weight: bold;
            color: #000 !important;
            display: flex;
            justify-content: space-between !important;
          }

          @media print {
            body {
              background: #fff !important;
            }
            .print-card {
              box-shadow: none;
              border: none;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-card">
          <h2>Payment Summary</h2>

          <div class="row">
            <label>Gl No:</label>
            <span>${row.loan_id}</span>
          </div>

          <div class="row">
            <label>Name:</label>
            <span>${row.name}</span>
          </div>

          <div class="row">
            <label>Date:</label>
            <span>${row.payment_date ? formatDate(row.payment_date) : "-"}</span>
          </div>

          <div class="row">
            <label>Time:</label>
            <span>${row.payment_date ? formatTime(row.payment_date) : "--:--:--"}</span>
          </div>

          <div class="row">
            <label>Principal Paid:</label>
            <span>₹${row.principal_paid}</span>
          </div>

          <div class="row">
            <label>Interest Paid:</label>
            <span>₹${row.interest_paid}</span>
          </div>

          <div class="total">
            <span>Total Paid:</span>
            <span>₹${(Number(row.principal_paid) + Number(row.interest_paid)).toFixed(2)}</span>
          </div>

          <div class="row" style="margin-top:10px;">
            <label>Balance:</label>
            <span>₹${row.balance}</span>
          </div>
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.print();
};



const formatDate = (dateStr) => {
  if (!dateStr || dateStr === "0000-00-00") return "—";

  const [datePart] = dateStr.split(" ");        // "2025-09-17"
  const [y, m, d] = datePart.split("-");        // ["2025","09","17"]

  return `${d}-${m}-${y}`;                      // "17-09-2025"
};



// Step 1: Flatten and sort the merged history by payment_date ascending
const sortedHistory = [...customer.mergedHistory].sort(
  (a, b) => new Date(a.payment_date) - new Date(b.payment_date)
);

// Step 2: Track first interest payment per month
const firstInterestByMonth = {};

// Step 3: Map for rendering
const rowsToRender = sortedHistory.map((p, i) => {
  const dateObj = new Date(p.payment_date);
  const monthKey = `${dateObj.getFullYear()}-${dateObj.getMonth()}`; // "2025-11" style

  let interestToShow = Number(p.interest_paid);

  // If this month already has a first interest row, set interest = 0
  if (firstInterestByMonth[monthKey]) {
    interestToShow = 0;
  } else if (interestToShow > 0) {
    // Mark this row as the first interest payment of the month
    firstInterestByMonth[monthKey] = true;
  }

  return {
    ...p,
    display_interest: interestToShow,
  };
});


const jewelName = customer?.jewel_name || "";

const isLongName =
  jewelName.includes(",") || jewelName.length > 25;


  
  return (
    <div>
      <Navbars />

      <div className="container all-modules-height card p-3">
        {/* ===== HEADER ===== */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-4">
          <h5 className="heading-with-line mb-2 mb-md-0 aquanew-text-effect">
            Customer View
            <hr className="smooth-line" />
          </h5>

          <button className="btn add-customer" onClick={handleBackCustomer}>
            <i className="fa fa-arrow-left me-2"></i> Back
          </button>
        </div>




     {/* ===== BASIC INFO ===== */}
<div  className="shadow p-4 mb-4" data-aos="fade-left">
  <h6 className="fw-bold mb-4">Customer Details</h6>

  <div className="d-flex align-items-start gap-5">

    {/* LEFT SIDE — CUSTOMER IMAGE */}

    
   <div
  style={{
    width: "130px",
    height: "130px",
    borderRadius: "12px",
    overflow: "hidden",
    // boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f0f0f0"
  }}
>
 <img
  src={
    customer?.liveImage?.altered_file_name
      ? `${baseURLs}${customer.liveImage.path}${customer.liveImage.altered_file_name}`
      : NoImage
  }
  alt="Customer"

  style={{
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain"
  }}
/>

</div>


    {/* RIGHT SIDE — DETAILS */}
    <div className="flex-grow-1">
      <div className="row">
        <div className="col-md-6">
          <p><strong>Name:</strong> {customer?.name|| '--'}</p>
          <p><strong>Guardian Name:</strong> {customer?.guardian_name || '--'}</p>
          <p><strong>Phone:</strong> {customer?.phone_no|| '--'}</p>
          <p><strong>Address:</strong> {customer?.address|| '--'}</p>
        </div>

        <div className="col-md-6">
<p><strong>Loan Start Date:</strong> {formatDate(customer?.date)}</p>

         <p>
  <strong>Total Loan Amount:</strong> ₹
  {customer?.additionalAmtDetails?.additional_loan_amt
    ? Number(customer?.previous_loan_amount) +
      Number(customer?.additionalAmtDetails?.additional_loan_amt)
    : customer?.previous_loan_amount}
</p>

{/* <p>
  <strong>Total Loan Amount:</strong> ₹
  {customer?.previous_loan_amount}
</p> */}

          <p><strong>Interest Rate:</strong> {customer?.intrest_rate}%</p>
          <p>
            <strong>Status:</strong>{" "}
            <span
              className={`badge bg-${
                loanStatus === "Closed" ? "danger" : "success"
              }`}
            >
              {loanStatus}
            </span>
          </p>
        </div>

{customer?.additionalAmtDetails &&
 customer?.additionalAmtDetails?.additional_loan_amt > 0 && (
  <div className="col-md-6 mt-4">

    <p>
      <strong>Additional Loan Start Date: </strong>
      {customer?.additionalAmtDetails?.additional_loan_date
        ? customer.additionalAmtDetails.additional_loan_date
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("-")
        : "-"}
    </p>

    <p>
      <strong>Additional Loan Amount: </strong> ₹
      {customer.additionalAmtDetails.additional_loan_amt}
    </p>

  </div>
)}




      </div>
    </div>

  </div>
</div>


<div>

       {/* ===== LOAN SUMMARY ===== */}
<div className="shadow-sm p-4 mb-4 rounded bg-white border" data-aos="fade-right">


  <h5 className="fw-bold mb-3 text-primary">Loan Summary</h5>






  <div className="row mb-3">

  {/* Total Loan Amount */}
  <div className={`mb-2 ${customer?.additionalAmtDetails?.additional_loan_amt ? "col-md-4" : "col-md-6"}`}>
    <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Loan Amount</small>
      <h6 className="fw-bold mt-1">₹{customer.previous_loan_amount}</h6>
    </div>
  </div>

   

  {/* Additional Loan Amount → show only if value exists */}
  {customer?.additionalAmtDetails?.additional_loan_amt && (
    <div className="col-md-4 mb-2">
      <div className="p-3 rounded border bg-light shadow">
        <small className="text-muted">Additional Loan Amount</small>
        <h6 className="fw-bold mt-1">
          ₹{customer.additionalAmtDetails.additional_loan_amt}
        </h6>
      </div>
    </div>
  )}

  {/* <div className={`mb-2 ${customer?.additionalAmtDetails?.additional_loan_amt ? "col-md-4" : "col-md-4"}`}>
    <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Jewel Less Weight & Jewel Amount</small>
      <h6 className="fw-bold mt-1">{customer?.jewel_weight} gram  ---  ₹{customer.jewel_amount}</h6>
    </div>
  </div> */}

  {/* Interest Rate */}
  <div className={`mb-2 ${customer?.additionalAmtDetails?.additional_loan_amt ? "col-md-4" : "col-md-6"}`}>
    <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Interest Rate</small>
      <h6 className="fw-bold mt-1">{customer.intrest_rate}%</h6>
    </div>
  </div>



<div className={isLongName ? "col-12 mt-3" : "col-md-4 mt-3"} >
  <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Jewel Name</small>
<h6 className="fw-bold mt-1">
  {customer?.jewel_name 
    ? `${customer.jewel_name}`
    : "0"}
</h6>
    </div>
</div>

{/* Jewel Weight */}
<div className={isLongName ? "col-md-4 mt-3" : "col-md-4 mt-3"}>
  <div className="p-3 rounded border bg-light shadow">
    <small className="text-muted">Jewel Weight</small>
    <h6 className="fw-bold mt-1">
      {customer?.jewel_dust_weight
        ? `${customer.jewel_dust_weight} Grams`
        : "0"}
    </h6>
  </div>
</div>

{/* Jewel Less Weight */}
<div className={isLongName ? "col-md-4 mt-3" : "col-md-4 mt-3"}>
  <div className="p-3 rounded border bg-light shadow">
    <small className="text-muted">Jewel Less Weight</small>
    <h6 className="fw-bold mt-1">
      {customer?.jewel_weight
        ? `${customer.jewel_weight} Grams`
        : "0"}
    </h6>
  </div>
</div>

{/* Jewel Amount */}

{/* <div className={isLongName ? "col-md-4 mt-3" : "col-md-3 mt-3"}>
  <div className="p-3 rounded border bg-light shadow">
    <small className="text-muted">Jewel Amount</small>
    <h6 className="fw-bold mt-1">
      ₹{customer?.jewel_amount || 0}
    </h6>
  </div>

</div> */}


</div>


  <hr />

  {/* Paid Details */}
  <h6 className="fw-bold mb-3">Payment Overview</h6>

  <div className="row">
    <div className="col-md-4 mb-3 ">
      <div className="p-3 rounded border shadow">
        <small className="text-muted">Principal Paid</small>
        <h6 className="fw-bold text-success mt-1">₹{principalPaid.toFixed(2)}</h6>
      </div>
    </div>

    <div className="col-md-4 mb-3">
      <div className="p-3 rounded border shadow">
        <small className="text-muted">Interest Paid</small>
        <h6 className="fw-bold text-info mt-1">₹{interestPaid.toFixed(2)}</h6>
      </div>
    </div>

    <div className="col-md-4 mb-3">
      <div className="p-3 rounded border shadow">
        <small className="text-muted">Total Paid</small>
        <h6 className="fw-bold text-primary mt-1">₹{totalPaid.toFixed(2)}</h6>
      </div>
    </div>
  </div>

  <hr />

  {/* Pending Interest Calculation */}


  {/* {(() => {
    const interestRate = Number(customer.intrest_rate || 0);
    const loanAmt = Number(customer.original_loan_amount || customer.loan_amount || 0);
    const expectedInterest = (loanAmt * interestRate) / 100;
    const paidInterest = Number(customer.interest_paid || 0);
    const lastPayment = customer.last_payment_date;
    const isFirstTime = !lastPayment || lastPayment === "0000-00-00" || paidInterest === 0;

    const pendingInterest =
      !isFirstTime && paidInterest < expectedInterest
        ? (expectedInterest - paidInterest).toFixed(2)
        : 0;

    const nextMonthSuggestion = (Number(expectedInterest) + Number(pendingInterest)).toFixed(2);

    return (
      <>
        {!isFirstTime && pendingInterest > 0 && (
          <div className="alert alert-warning rounded mt-3">
            <strong>⚠ Pending Interest:</strong> ₹{pendingInterest} <br />
            <small className="text-muted">
              Next Month Suggested Interest: <strong>₹{nextMonthSuggestion}</strong>
            </small>
          </div>
        )}
      </>
    );
  })()} */}



{(() => {
  const expectedInterest = Number(customer.intrest_amount || 0); 
  const paidInterest = Number(customer.interest_paid || 0);    

  console.log(paidInterest,expectedInterest);
  

  const pendingInterest =
    paidInterest < expectedInterest
      ? (expectedInterest - paidInterest).toFixed(2)  
      : 0;

  console.log(pendingInterest);
  

  const nextMonthInterest = (
    Number(expectedInterest) + Number(pendingInterest) // 50 + 10 = 60
  ).toFixed(2);

  return (
    <>
      {pendingInterest > 0 && (
        <div className="alert alert-warning rounded mt-3">
          <strong>⚠ Pending Interest:</strong> ₹{pendingInterest} <br />
          <small className="text-muted">
            Next Month Interest: <strong>₹{nextMonthInterest}</strong>
          </small>
        </div>
      )}
    </>
  );
})()}




  {/* Remaining Balance */}
  <div className="p-3 rounded border bg-light mt-3 shadow">
    <small className="text-muted">Remaining Principal Balance</small>
    <h6 className="fw-bold text-danger mt-1">₹{balance}</h6>
  </div>

 {/* Last Payment Date */}
<p className="mt-3">
  <strong>Last Payment Date:</strong>{" "}
  {(() => {
    const newData = customer?.existing_details?.[0]?.new_data;

    // 1. If no previous payment
    if (!customer?.existing_details?.length) {
      return (
        <span className="text-muted">No payments made yet</span>

      );
    }

    // 2. If new_data payment date exists
    if (newData?.payment_date && newData.payment_date !== "0000-00-00") {
      const [datePart, timePart] = newData.payment_date.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);
      const local = new Date(year, month - 1, day, hour, minute, second);

      const formattedDate = local.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      const formattedTime = local.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return `${formattedDate} ${formattedTime}`;
    }

    // 3. Fallback: customer.last_payment_date
    if (
      customer?.last_payment_date &&
      customer.last_payment_date !== "0000-00-00"
    ) {
      return new Date(customer.last_payment_date).toLocaleDateString("en-IN");
    }

    return "—";
  })()}
</p>


  {customer?.closed_date && (
    <p>
      <strong>Closed Date:</strong> {customer.closed_date}
    </p>
  )}
</div>


{/* ===== MONTHLY PAYMENT HISTORY ===== */}

<div   className="shadow p-4 mb-4">
  <div  id="viewprint">
  {/* <h6 className="fw-bold mb-3">📅 Monthly Payment History</h6> */}
  <div className="d-flex align-items-center mb-3">
  <h6 className="fw-bold mb-3">📅 Monthly Payment History</h6>



</div>

  {Array.isArray(customer.mergedHistory) && customer.mergedHistory.length > 0 ? (
    <table  className="table table-striped" data-aos="fade-up">
      <thead>
        <tr>
          <th>Sl No</th>
          <th>Payment Date</th>
          <th>Payment Time</th>
          <th>Principal Paid</th>

          <th>Interest Paid</th>
          <th>Total Paid</th>
          <th>Remaining Balance</th>
          <th>Print</th>
        </tr>
      </thead>
    <tbody>
  {rowsToRender.map((p, i) => {
    const [datePart, timePart] = (p.payment_date || "-").split(" ");
    return (
      <tr key={i}>
        <td>{p.month_no}</td>
        <td>{datePart !== "-" ? formatDate(p.payment_date) : "-"}</td>
        <td>{timePart ? formatTime(p.payment_date) : "--:--:--"}</td>
        <td>₹{p.principal_paid}</td>
        <td>₹{p.display_interest}</td>
        <td>₹{(Number(p.principal_paid) + p.display_interest).toFixed(2)}</td>
        <td>₹{p.balance}</td>
        <td
          style={{ border: "none", color: "blue", cursor: "pointer" }}
          onClick={() => handlePrint(p)}
        >
          <FaPrint size={18} />
        </td>
      </tr>
    );
  })}
</tbody>

    </table>
  ) : (
    <p className="text-muted">No payment history available</p>
  )}

  
  </div>
</div>

</div>

     {/* ===== FANCY IMAGE CARDS SECTION ===== */}

{/* <div className="shadow p-4 mb-4" data-aos="fade-up">
  <h6 className="fw-bold mb-3">Uploaded Images</h6>

  <div className="row">

<div className="col-md-6">
  <p className="text-center fw-bold mt-2">Aadhaar Front</p>

  <div className="fancy-card-image">
    <img
      src={
        customer.aadharImage?.[0]
          ? `${baseURLs}${customer?.aadharImage[0].path}${customer?.aadharImage[0].altered_file_name}`
          : NoImage
      }
      alt="Aadhaar Front"
       className="fancy-img"
    />
  </div>
</div>

<div className="col-md-6">
  <p className="text-center fw-bold mt-2">Aadhaar Back</p>

  <div className="fancy-card-image">
    <img
      src={
        customer?.aadharImage?.[1]
          ? `${baseURLs}${customer?.aadharImage[1].path}${customer?.aadharImage[1].altered_file_name}`
          : NoImage
      }
      alt="Aadhaar Back"
       className="fancy-img"
    />
  </div>
</div>


    <div className="col-md-6 mt-2">
      <p className="text-center fw-bold mt-2">Jewel Image</p>

      <div className="fancy-card-image">
        <img
          src={
            customer?.jewelImg
              ? `${baseURLs}${customer?.jewelImg?.path}${customer?.jewelImg?.altered_file_name}`
              : NoImage
          }
          alt="Jewel"
           className="fancy-img"
        />
      </div>
    </div>

    <div className="col-md-6 mt-2">
      <p className="text-center fw-bold mt-2">Opt Image</p>

      <div className="fancy-card-image">
        <img
          src={
            customer?.optionalImg
              ? `${baseURLs}${customer?.optionalImg?.path}${customer?.optionalImg?.altered_file_name}`
              : NoImage
          }
          alt="opt"
           className="fancy-img"
        />
      </div>
    </div>


  </div>
</div> */}


<div className="shadow p-4" data-aos="fade-up">
  <h6 className="fw-bold mb-4">Uploaded Images</h6>
  <div className="row">
    
    <div className="col-md-3">
      <div className="card-view p-0">
        
        <div className="fancy-card-image">
         <img
      src={
        customer.aadharImage?.[0]
          ? `${baseURLs}${customer?.aadharImage[0].path}${customer?.aadharImage[0].altered_file_name}`
          : NoImage
      }
      alt="Aadhaar Front"
       className="fancy-img"
    />
        </div>

        <div className="card-content d-flex flex-column align-items-center">
          <h4 className="pt-2 image-content-letter">Aadhar Front Image</h4>
         

        </div>

      </div>
    </div>

     <div className="col-md-3">
      <div className="card-view p-0">
        
        <div className="fancy-card-image">
         <img
      src={
        customer?.aadharImage?.[1]
          ? `${baseURLs}${customer?.aadharImage[1].path}${customer?.aadharImage[1].altered_file_name}`
          : NoImage
      }
      alt="Aadhaar Back"
       className="fancy-img"
    />
        </div>

        <div className="card-content d-flex flex-column align-items-center">
          <h4 className="pt-2 image-content-letter">Aadhar Back Image</h4>

          {/* <ul className="social-icons d-flex justify-content-center">
            <li style={{ "--i": 1 }}>
              <a href="#">
                <span className="fab fa-facebook"></span>
              </a>
            </li>

            <li style={{ "--i": 2 }}>
              <a href="#">
                <span className="fab fa-twitter"></span>
              </a>
            </li>

            <li style={{ "--i": 3 }}>
              <a href="#">
                <span className="fab fa-instagram"></span>
              </a>
            </li>
          </ul> */}

        </div>

      </div>
    </div>


     <div className="col-md-3">
      <div className="card-view p-0">
        
        <div className="fancy-card-image">
         <img
          src={
            customer?.jewelImg
              ? `${baseURLs}${customer?.jewelImg?.path}${customer?.jewelImg?.altered_file_name}`
              : NoImage
          }
          alt="Jewel"
           className="fancy-img"
        />
        </div>

        <div className="card-content d-flex flex-column align-items-center">
          <h4 className="pt-2 image-content-letter">Jewel Image</h4>

       

        </div>

      </div>
    </div>


     <div className="col-md-3">
      <div className="card-view p-0">
        
        <div className="fancy-card-image">
         <img
          src={
            customer?.optionalImg
              ? `${baseURLs}${customer?.optionalImg?.path}${customer?.optionalImg?.altered_file_name}`
              : NoImage
          }
          alt="opt"
           className="fancy-img"
        />
        </div>

        <div className="card-content d-flex flex-column align-items-center">
          <h4 className="pt-2 image-content-letter">Optional Image</h4>
          

        </div>

      </div>
    </div>

  </div>
</div>


      </div>
    </div>
  );
}

export default CustomerView;
